import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <section className="bg-brand-black text-white min-h-[60vh] grid place-items-center">
      <div className="text-center container-px">
        <span className="font-display font-black text-7xl text-brand-red">404</span>
        <h1 className="font-display font-extrabold text-2xl mt-4 mb-3">Página não encontrada</h1>
        <p className="text-gray-300 mb-7">A página que você procura não existe ou foi movida.</p>
        <Link to="/" className="btn-red"><HomeIcon className="w-5 h-5" /> Voltar ao início</Link>
      </div>
    </section>
  );
}
